import { Stack } from '@mui/material';
import { PageHeaderStatic, WidgetIcon } from '@procureai/ui-mui';

import { UserDomainType } from '~/common/types';
import { DataGridQueryBuilder, useDataGridQueryBuilderQuery } from '~/components/DataGridQueryBuilder';
import { DomainIcon } from '~/components/DomainIcon/DomainIcon';
import { Filters, FilterSaveStatus, useFilters } from '~/components/Filters';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { UserAvailabilityWidget } from '~/modules/UserAvailabilityWidget/UserAvailabilityWidget';

import { DateRangeSelect } from './components/DateRangeSelect/DateRangeSelect';
import { UserPageTitle } from './components/UserPageTitle/UserPageTitle';
import { useUserAvailabilityList } from './UserAvailabilityList.hooks';
import { useUserAvailabilityDataGridQueryBuilderConfig } from './UserAvailabilityList.queryBuilder';

const domain = UserDomainType.USER_AVAILABILITY;

export const UserAvailabilityList = () => {
  const { queryId, query, onQueryChange, onQueryIdChange, rulesTotal } = useDataGridQueryBuilderQuery({
    domain,
  });
  const { dateRange, onDateRangeChange } = useUserAvailabilityList();
  const { onFilterSave, saveStatus, selected, ...filtersProps } = useFilters({ domain, queryId });

  return (
    <PageLayout
      fullHeight
      renderHeader={
        <>
          <PageHeaderStatic
            title={<UserPageTitle domain={domain} />}
            maxWidth={false}
            icon={<WidgetIcon icon={<DomainIcon domain={domain} />} />}
            right={
              <Stack
                spacing={3}
                direction="row"
                sx={{
                  alignItems: 'center',
                }}
              >
                <DateRangeSelect value={dateRange} onChange={onDateRangeChange} />
                <Filters
                  {...filtersProps}
                  selected={selected}
                  onFilterSelect={(filter) => {
                    onQueryIdChange(filter.queryId);
                  }}
                />
              </Stack>
            }
          />
          <DataGridQueryBuilder
            query={query}
            clearDisabled={rulesTotal === 0}
            saveDisabled={saveStatus === FilterSaveStatus.DISABLED}
            onQueryChange={onQueryChange}
            onSave={onFilterSave}
            selectedFilterName={selected?.name}
            useConfig={useUserAvailabilityDataGridQueryBuilderConfig}
          />
        </>
      }
    >
      <UserAvailabilityWidget dateRange={dateRange} filter={query} filterCount={rulesTotal} />
    </PageLayout>
  );
};
